import { API_URL } from "../../utils/contextHelpers";
import { api, apiPost } from "./core";
import { getAffariAlmacenRaw, getAffariListaPrecioBaseRaw, getAffariCanal } from "./authService";

export const getBanners = api("getBanners", ({ canal = "" } = {}) => {
    const params = new URLSearchParams();
    if (canal) params.set("canal", canal);
    const query = params.toString();
    return `${API_URL}banners${query ? `?${query}` : ""}`;
});

export const getCategorias = api("getCategorias",
  ({
    tipo = getAffariCanal(),
    limiteCategorias = "",
    tipoCategorias = "",
    idsFamilias = "",
  } = {}) => {
    const params = new URLSearchParams();
    if (tipo) params.set("tipo", tipo);
    if (String(limiteCategorias || "").trim()) params.set("limiteCategorias", limiteCategorias);
    if (String(tipoCategorias || "").trim()) params.set("tipoCategorias", tipoCategorias);
    if (String(idsFamilias || "").trim()) params.set("idsFamilias", idsFamilias);
    const query = params.toString();
    return `${API_URL}cache/categorias${query ? `?${query}` : ""}`;
  }
);

export const getDestacados = api( "getDestacados",
  ({
    almacen = getAffariAlmacenRaw(),
    listaPrecio = getAffariListaPrecioBaseRaw(),
    tipo = getAffariCanal(),
    tipoDestacados = "",
    limiteDestacados = "",
    codigos = "",
  } = {}) => {
    const params = new URLSearchParams();
    if (almacen) params.set("almacen", almacen);
    if (listaPrecio) params.set("listaPrecio", listaPrecio);
    if (tipo) params.set("tipo", tipo);
    if (String(tipoDestacados || "").trim()) params.set("tipoDestacados", tipoDestacados);
    if (String(limiteDestacados || "").trim()) params.set("limiteDestacados", limiteDestacados);
    if (String(codigos || "").trim()) params.set("codigos", codigos);
    const query = params.toString();
    return `${API_URL}cache/destacados${query ? `?${query}` : ""}`;
  }
);

export const getContenidos = api("getContenidos", () => `${API_URL}contenidos`);

export const getContenidosCache = api("getContenidosCache", () => `${API_URL}cache/contenidos`);

export const getContenidoSlug = api("getContenidoSlug", (slug) => `${API_URL}contenidos/${encodeURIComponent(String(slug || "").trim())}`);

export const editarContenido = apiPost("editarContenido",
    (id) => `${API_URL}contenidos/editar?id=${encodeURIComponent(id)}`,
    { contentType: "application/json;charset=UTF-8", body: (id, jsonData) => JSON.stringify(jsonData) }
);

export const refreshContenidosCacheBackEnd = api("refreshContenidosCache", () => `${API_URL}cache/contenidos/refresh`);